import styled from "styled-components";

export const Header = styled.h2`
  color: var(--fixit);
`

export const Container = styled.div`
  padding: 1rem 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 5px;

  b{
    color: var(--dark-gray);
  }

  span{
    color: var(--dark-gray)
  }
`
